import styled from 'styled-components';

import { Div, DefaultTheme } from '@pinpoint/design-kit';

const ProgressBar = styled(Div)`
  width: ${(props) => props.width}%;
  background: ${(props) => DefaultTheme.colors[props.bg] || props.bg};
  height: ${(props) => props.h};
  position: absolute;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
  border-radius: 0px 16px 16px 0px;
  transition: ${(props) => props.transition};
  z-index: 999;
  box-shadow: 0 0 1px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}400`]},
    0 0 2px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}400`]},
    0 0 3px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}300`]},
    0 0 4px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}300`]},
    0 0 5px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}200`]},
    0 0 6px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}200`]},
    0 0 7px ${({ shadowTheme }) => DefaultTheme.colors[`${shadowTheme}100`]};
`;

ProgressBar.defaultProps = {
  width: '0',
  shadowTheme: 'warning',
  h: '0.25rem',
  bg: 'warning500',
  top: '0',
  left: '0',
  transition: 'width 0.2s',
  theme: DefaultTheme,
};

export default ProgressBar;
